import React from "react";
import { Grid } from "@mui/material";
import AADataTable from "./AADataTable";

interface UserListGridProps {
  columns: any[];
  rows: any[];
  height: string | number;
  onDoubleClick?: (
    params: any,
    event: React.MouseEvent<HTMLElement>,
    details: any
  ) => void;
  sortColumn?: any;
  updateSortColumn?: (model: any) => void;
}

const UserListGrid: React.FC<UserListGridProps> = ({
  columns,
  rows,
  height,
  onDoubleClick,
  sortColumn,
  updateSortColumn,
}) => {
  return !rows ? (
    <h1>Loading</h1>
  ) : (
    <Grid container justifyContent="flex-start" sx={{ height }}>
      <Grid item xs={12} sx={{ mt: 2, height }}>
        <AADataTable
          columnData={columns}
          rowData={rows}
          handleDoubleClick={onDoubleClick}
          sortCol={sortColumn}
          updateSortCol={updateSortColumn}
        />
      </Grid>
    </Grid>
  );
};

export default UserListGrid;
